module.exports = __webpack_public_path__ + "img/C04TechGalley2_ua.15347c74.webp";